import React from 'react';
import { SEO } from './components/SEO';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { USPBar } from './components/USPBar';
import { Services } from './components/Services';
import { CorePrintBlock } from './components/CorePrintBlock';
import { Branches } from './components/Branches';
import { ClientCases } from './components/ClientCases';
import { Reviews } from './components/Reviews';
import { WerkgebiedSection } from './components/WerkgebiedSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Werkproces } from './components/Werkproces';
import { TeamCarousel } from './components/TeamCarousel';
import { BlogSection } from './components/BlogSection';
import { FAQ } from './components/FAQ';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
import { localBusinessSchema, websiteSchema, buildFAQSchema } from './lib/structuredData';
import { homeFaqs } from './data/faq';
export function App() {
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans" data-id="element-0" data-mp="3ijpd910hgz9r">
      <SEO title="Online marketing en SEO in Alkmaar en Noord-Holland Noord | Noord Digital" description="Noord Digital uit Oudkarspel, vlak bij Alkmaar, zorgt dat ondernemers in Noord-Holland Noord online gevonden worden en professioneel overkomen. SEO, websites, vormgeving, webapplicaties, hosting en e-mail." keywords="online marketing alkmaar, seo alkmaar, online zichtbaarheid noord-holland noord, webapplicatie laten maken alkmaar, online zichtbaarheid heerhugowaard, lokale seo dijk en waard, huisstijl laten maken" canonical="https://noorddigital.nl/" jsonLd={[localBusinessSchema, websiteSchema, buildFAQSchema(homeFaqs)]} data-id="element-1" data-mp="3mk85uxa7a9d0" />
      <Header data-id="element-2" data-mp="3diry6xarslch" />
      <Hero data-id="element-3" data-mp="nvj35ett6cp7" />
      <USPBar data-id="element-4" data-mp="nw2ay2pqvkpi" />
      <div id="services" className="scroll-mt-24" data-id="element-5" data-mp="nwc1brepbtvq">
        <Services data-id="element-6" data-mp="nxwxflgnzkvp" />
      </div>
      <CorePrintBlock data-id="element-7" data-mp="su44xiopl4fr" />
      <Branches data-id="element-8" data-mp="stkok6epio3u" />
      {/* De id client-cases staat op de sectie binnen ClientCases zelf,
          samen met de scroll-offset. Hier geen tweede id plaatsen. */}
      <ClientCases data-id="element-9" data-mp="3ud1gzdqblwcq" />
      <WerkgebiedSection data-id="element-10" data-mp="3udkoe0ich2ci" />
      <Reviews data-id="element-11" data-mp="3uc9l01st9wlx" />
      <GuaranteeSection data-id="element-12" data-mp="3ucj8niqdvrog" />
      <Werkproces data-id="element-13" data-mp="d4nv7fl6zi1v" />
      <TeamCarousel data-id="element-14" data-mp="d57fh2ybeij2" />
      <BlogSection data-id="element-15" data-mp="d3cu5nj4soeg" />
      <FAQ data-id="element-16" data-mp="d3wch5cp1et0" />
      <ContactForm data-id="element-17" data-mp="d2l7j27ii10b" />
      <Footer data-id="element-18" data-mp="85l0anyxes7m" />
    </div>;
}